export const doctorTypes = {
  '7305440f-78fb-48bf-9c16-65a64b04184a': 'Невролог: пожилой',
  '4ff5f53a-0380-4a1e-a588-ab929dc8ceb1': 'Невролог: мигрень',
  '5f4de11b-ab59-47cb-b7ea-86e0f6f290e9': 'Терапевт: коморбид',
  'a969011e-10d2-4ca5-abbf-76ce3c624c54': 'Терапевт: молодой',
};

export const SERVER_URL = 'https://api.office.onpoint.ru/app1/';
const TOKEN = '9533f871-07d7-45ff-b5de-699790ee7e52';
export const SET_CONTEXT_URL = `${SERVER_URL}setContext?token=${TOKEN}`;
export const SEND_MESSAGE_URL = `${SERVER_URL}chat?token=${TOKEN}`;
export const GET_RESULT_URL = `${SERVER_URL}getStats?token=${TOKEN}`;
